import actions from "./auth.actions";

export default {
  namespaced: true,
  actions,
};
